export default __webpack_public_path__ + "static/media/Revision.78150939.svg";